export default __webpack_public_path__ + "static/media/profile.ddf3bbcf.jpg";